"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonProps = void 0;
const vue_strict_prop_1 = __importDefault(require("vue-strict-prop"));
exports.commonProps = {
    name: (0, vue_strict_prop_1.default)(String).optional,
    legend: (0, vue_strict_prop_1.default)(String).required,
    description: vue_strict_prop_1.default.ofType().optional,
    disabled: (0, vue_strict_prop_1.default)(Boolean).default(false),
    readonly: (0, vue_strict_prop_1.default)(Boolean).default(false),
    variant: vue_strict_prop_1.default.ofStringLiterals('default', 'card-like', 'quiz').default('default'),
    legendClasses: vue_strict_prop_1.default.ofType().optional,
    optionClasses: vue_strict_prop_1.default.ofType().optional,
    optionsWrapperClasses: vue_strict_prop_1.default.ofType().optional,
    optionLabelClass: vue_strict_prop_1.default.ofType().default('label-large'),
};
